/**
 * @generated SignedSource<<fa29a15765b6660e518be53d889e8dc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type tritxApplyRefundMutation$variables = {
  accountNo: string;
  accountOwner: string;
  bank: string;
  metaProperties?: string | null | undefined;
  phoneNumber: string;
  refundId: string;
  utmCampaign?: string | null | undefined;
  utmContent?: string | null | undefined;
  utmMedium?: string | null | undefined;
  utmSource?: string | null | undefined;
  utmTerm?: string | null | undefined;
};
export type tritxApplyRefundMutation$data = {
  readonly tritxApplyRefund: {
    readonly errors: {
      readonly code: ErrorType;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type tritxApplyRefundMutation = {
  response: tritxApplyRefundMutation$data;
  variables: tritxApplyRefundMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountNo"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountOwner"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bank"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metaProperties"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phoneNumber"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmCampaign"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmContent"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmMedium"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmSource"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmTerm"
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountNo",
        "variableName": "accountNo"
      },
      {
        "kind": "Variable",
        "name": "accountOwner",
        "variableName": "accountOwner"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "campaign",
            "variableName": "utmCampaign"
          },
          {
            "kind": "Variable",
            "name": "content",
            "variableName": "utmContent"
          },
          {
            "kind": "Variable",
            "name": "medium",
            "variableName": "utmMedium"
          },
          {
            "kind": "Variable",
            "name": "source",
            "variableName": "utmSource"
          },
          {
            "kind": "Variable",
            "name": "term",
            "variableName": "utmTerm"
          }
        ],
        "kind": "ObjectValue",
        "name": "applyUtm"
      },
      {
        "kind": "Variable",
        "name": "bank",
        "variableName": "bank"
      },
      {
        "kind": "Variable",
        "name": "metaProperties",
        "variableName": "metaProperties"
      },
      {
        "kind": "Variable",
        "name": "phoneNumber",
        "variableName": "phoneNumber"
      },
      {
        "kind": "Variable",
        "name": "refundId",
        "variableName": "refundId"
      }
    ],
    "concreteType": "ApplyRefundOutput",
    "kind": "LinkedField",
    "name": "tritxApplyRefund",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "tritxApplyRefundMutation",
    "selections": (v11/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v10/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "tritxApplyRefundMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "40d5e99bb156ba9d4503f0ad20ec3e38",
    "id": null,
    "metadata": {},
    "name": "tritxApplyRefundMutation",
    "operationKind": "mutation",
    "text": "mutation tritxApplyRefundMutation(\n  $refundId: String!\n  $phoneNumber: String!\n  $bank: String!\n  $accountOwner: String!\n  $accountNo: String!\n  $metaProperties: String\n  $utmSource: String\n  $utmMedium: String\n  $utmCampaign: String\n  $utmTerm: String\n  $utmContent: String\n) {\n  tritxApplyRefund(refundId: $refundId, phoneNumber: $phoneNumber, bank: $bank, accountOwner: $accountOwner, accountNo: $accountNo, metaProperties: $metaProperties, applyUtm: {source: $utmSource, medium: $utmMedium, campaign: $utmCampaign, term: $utmTerm, content: $utmContent}) {\n    result\n    errors {\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fef44ccda712517b87d80830f0bab661";

export default node;
